'use client'

import React from 'react'
import ProfileEmptyState from './ProfileEmptyState'
import { FollowButton } from '@/components/folllowButton'
import { transformUserObject } from '@/lib/utils'

export const VISITOR_RECIPE_EMPTY_IMAGE = '/assets/empty-state/visitor-recipe-empty-state.svg'
export const GENERAL_MEMBER_RECIPE_EMPTY_IMAGE = '/assets/empty-state/premium-recipe-empty-state.svg'

export function getRecipeFollowTargetLabel(userType?: string | null) {
  const type = userType?.toLowerCase()
  if (type === 'producer') return 'farm'
  if (type === 'market') return 'market'
  return 'member'
}

export function getVisitorRecipeEmptyStateCopy(userType?: string | null) {
  const followTarget = getRecipeFollowTargetLabel(userType)
  return {
    title: 'No recipes shared yet',
    description: `Follow this ${followTarget} to get notified when they publish seasonal recipes.`,
  }
}

interface VisitorRecipeEmptyStateProps {
  userProfile: {
    user_id?: number
    user_type?: string | null
    slug?: string | null
    full_name?: string | null
    profile_photo_resource?: string | null
    default_listing?: { slug?: string | null; photo?: string | null } | null
  }
}

export function VisitorRecipeEmptyState({ userProfile }: VisitorRecipeEmptyStateProps) {
  const copy = getVisitorRecipeEmptyStateCopy(userProfile?.user_type)
  const userType = userProfile?.user_type?.toLowerCase()
  const image =
    userType === 'producer' || userType === 'market'
      ? VISITOR_RECIPE_EMPTY_IMAGE
      : GENERAL_MEMBER_RECIPE_EMPTY_IMAGE

  return (
    <ProfileEmptyState
      image={image}
      title={copy.title}
      description={copy.description}
      buttons={[
        {
          customElement: (
            <FollowButton user={transformUserObject(userProfile)} />
          ),
        },
      ]}
    />
  )
}
